// extracted by mini-css-extract-plugin
module.exports = {"boxSobre":"Sobre_boxSobre__aBVTM","imgSobre":"Sobre_imgSobre__24vBr"};